import styled from 'styled-components';

const ErrorMessage = styled.div`
  width: 300px;
  margin: auto;
  padding: 20px;
  border: 3px solid red;
  border-radius: 25px;
  background-color: #ffaba1;
`;

export { ErrorMessage };



// WEBPACK FOOTER //
// ./src/components/UI/ErrorMessage.jsx